// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import featureMng from './metaData/feature'
export default {
  state: featureMng,
  actions
}
